export const isPresent = (value: string | null | number | undefined) => {
    return (
        typeof value !== "undefined" &&
        value !== undefined &&
        value != null &&
        value !== "" &&
        (typeof value !== "number" || isFinite(value))
    );
};